<template>
	<div id="songs">
		<div class="song" v-for="song in externalSongs" v-bind:key="song.id" @click="selectSong(song)" :class="{ active: currentSong !== null && currentSong.songId === song.id }">
			{{ song.title }} <span v-if="song.isChecked">👍&nbsp;</span>
			<small>{{ song.author }}</small>
		</div>
	</div>
</template>

<script>
	import { mapState } from "vuex";

	export default {
		data() {
			return {
				currentSongIndex: null
			};
		},
		computed: {
			...mapState([ "externalSongs", "currentSong", "externalSearchOpened", "localSearchOpened" ]),
			songsIds() {
				return this.externalSongs.map(s => s.id);
			}
		},
		methods: {
			selectSong(song) {
				this.$store.commit("setCurrentSong", song);
				this.$router.push({ name: "zpevnik-song", params: { song: song.id } });
			},
			keydownEvent(e) {
				if (this.localSearchOpened) return;
				if (!this.externalSearchOpened) return;
				if (e.srcElement.tagName === "TEXTAREA") return;
				if (!(e.code === "ArrowDown" || e.code === "ArrowUp")) return;

				if (this.currentSong !== null) {
					if (!(this.currentSongIndex !== null && typeof this.songsIds[this.currentSongIndex] !== "undefined" && this.songsIds[this.currentSongIndex] === this.currentSong.songId)) {
						this.currentSongIndex = this.songsIds.indexOf(this.currentSong.songId);
					}
				}

				if (this.currentSongIndex === -1 || this.currentSongIndex === null) {
					this.currentSongIndex = 0;
					this.selectSong(this.externalSongs[this.currentSongIndex]);
					return;
				}

				if (e.code === "ArrowDown") {
					if (this.currentSongIndex >= 0 && this.currentSongIndex < this.songsIds.length - 1) {
						this.currentSongIndex += 1;
						this.selectSong(this.externalSongs[this.currentSongIndex]);
					}
				} else if (e.code === "ArrowUp") {
					if (this.currentSongIndex >= 1) {
						this.currentSongIndex -= 1;
						this.selectSong(this.externalSongs[this.currentSongIndex]);
					}
				}
			},
			handleScroll() {
				if (this.$refs.externalSongs) {
					this.$refs.externalSongs.handleScroll()
				}
			}
		},
		mounted() {
			document.addEventListener("keyup", this.keydownEvent);
		},
		destroyed() {
			document.removeEventListener("keyup", this.keydownEvent);
		}
	}

</script>

<style lang="scss" scoped>
	@import "./public/scss/_variables.scss";

	#songs {
		.song {
			cursor: pointer;
			background-color: $DARK-background-no-opacity-color;
			margin-bottom: 1px;
			padding: 7px 15px 7px 15px;
			line-height: 30px;
			color: rgba(255, 255, 255, 0.9);
			font-weight: 300;

			&.active {
				background-color: rgba(180, 177, 186, 0.33);
			}
		}

		.song:hover {
			background-color: $DARK-background-opacity-color;
		}

		.song > small {
			display: block;
			opacity: 0.5;
			line-height: 20px;
		}
	}


</style>
